import React from "react"
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
  ZoomableGroup,
} from "react-simple-maps"
import styled from "styled-components"

import { Settings } from "../../../styles/theme"

const windowGlobal = typeof window !== "undefined" && window

const Contact = color => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="77.779"
    viewBox="0 0 50 77.779"
  >
    <g id="orange" transform="translate(25 38.889)">
      <g id="Group_138" data-name="Group 138" transform="translate(-25 -38.89)">
        <path
          id="Path_106"
          data-name="Path 106"
          d="M23.955,0A23.955,23.955,0,0,0,0,23.955C0,37.072,23.955,77.282,23.955,77.282S47.624,37.072,47.624,23.955A23.955,23.955,0,0,0,23.953,0Zm0,42.206A17.966,17.966,0,1,1,41.92,24.24,17.966,17.966,0,0,1,23.955,42.206Z"
          transform="translate(1.136 0.497)"
          fill={color.color}
        />
      </g>
    </g>
  </svg>
)

const geoUrl =
  "https://raw.githubusercontent.com/zcreativelabs/react-simple-maps/master/topojson-maps/world-110m.json"

const data = [
  {
    country: "CHINA",
    name: "Mr. Li Wenbing (李文兵)",
    company: "Acevision (Beijing) Exhibition Co.,Ltd.",
    address:
      "Room 518, Youcheng Plaza, No.16, Beitucheng West Road, Chaoyang, Beijing 100015, China",
    tel: "+86 136 2133 9701",
    email: "wenbing[at]acevision-expo.com",
    x: "78%",
    y: "15%",
  },
  {
    country: "GERMANY",
    name: "Mr Kristian Schiscke",
    company: "ECM Expo & Conference Management GmbH",
    address: "Katharinenstraße 8, 10711 Berlin, Germany",
    tel: "+49 30 61 78 43 40",
    fax: "+49 30 61 78 43 49",
    email: "ks[at]ecm-berlin.de",
    x: "2%",
    y: "30%",
  },
  {
    country: "ROMANIA",
    name: "Mr. George E Tudor-Boruzi",
    company: "Serraplana Ltd",
    address:
      "Bd Ion Mihalache No 313 BL 1SC A ET 3 AP 7 Sector 1 Bucharest 011183 Romania",
    tel: "Tel: +33 (0) 1 565 9 15 21",
    email: "getb[at]serraplana.com",
    x: "3%",
    y: "10%",
  },
  {
    country: "NETHERLANDS",
    name: "Ms. Liselotte Zoetmulder",
    company: "Netherlands Aerospace Group",
    address: "Molengraaffsingel 10, 2629 JD Delft, The Netherlands",
    tel: "+31 88 1976 108",
    email: "liselotte.zoetmulder[at]nag.aero",
    x: "20%",
    y: "0%",
  },
  {
    country: "ISRAEL",
    name: "Mr David Litvak",
    company: "Honeycomb SMTM Asia Pte Ltd",
    address: "6/103 Zamarot St, Herzelia 46424, Israel",
    mobile: "+972 502 444444",
    email: "dudi[at]gmss.co.il",
    x: "30%",
    y: "80%",
  },
  {
    country: "INDIA",
    name: "Ms Preethi M Vallatu",
    company: "Aerosun Media Pvt Ltd.",
    address:
      "# B2, Sapphire, Prakruthi Township, 1st Block, 3rd Cross, Babusapalya, Kalyan Nagar, Bangalore, 560043, Karnataka, India",
    tel: "+91 80 43747492",
    mobile: "+91 9448447509",
    email: "preethim[at]aeromag.in",
    x: "50%",
    y: "70%",
  },
  {
    country: "JAPAN",
    name: "Noriko Kodama",
    company: "APT Planning Co., Ltd.",
    address: "2-8-16-6F Ote-machi Naka-ku, Hiroshima City, Japan 730-0051",
    tel: "+81 82 298 1740",
    mobile: "+81 90 1367 8148",
    email: "kodama[at]aptplanning.jp",
    x: "80%",
    y: "40%",
  },
  {
    country: "SWITZERLAND",
    name: "Mr. Alexander Winterstein",
    company: "T-Link Management Ltd",
    address: "Schwerzistrasse 6, Freienbach 8807, Switzerland",
    tel: "+41 43 288 18 86",
    fax: "+41 43 288 18 99",
    email: "a.winterstein[at]t-link.ch",
    x: "40%",
    y: "0%",
  },
  {
    country: "UNITED STATES OF AMERICA",
    name: "Mr. Mike Petrassi",
    company: "Kallman Worldwide Inc.",
    address: "4 North Street, Suite 800 Waldwick, New Jersey 07463-1842 USA",
    tel: "+1 201 251 2600",
    fax: "+40 762-603 145",
    email: "mikep[at]kallman.com",
    x: "8%",
    y: "80%",
  },
  {
    country: "CANADA",
    name: "Mr. Derek Staines",
    company: "EAS Exhibition Services Inc",
    address:
      "1400 Bayly Street, Office Mall 2, Unit 4, Pickering, Ontario, L1W 3R2 Canada",
    tel: "+1 905 837 5095",
    fax: "+1 905 837 1544",
    mobile: "+1 416 399 8257",
    email: "derek[at]easexhibitions.com",
    x: "4%",
    y: "55%",
  },
  {
    country: "AUSTRIA",
    name: "Dr. Gerhard Eisenhut",
    company: "Castellana Business Development GmbH",
    address: "Kramergasse 9/5, A-1010 Vienna, Austria",
    tel: "+43 1 533 65 05 10",
    fax: "+43 1 533 65 05 50",
    mobile: "+43 6 802 182 491",
    email: "geisenhut[at]castellana.at",
    x: "70%",
    y: "65%",
  },
  {
    country: "RUSSIA",
    name: "Mr. Alexander Velovich",
    company: "Hawk-Russia",
    address: "P.O. Box 15, Moscow 115 455, Russia",
    tel: "+7 499 615 7028",
    fax: "+7 499 151 6150",
    mobile: "+7 910 400 0225",
    email: "a.velovich[at]gmail.com",
    x: "58%",
    y: "3%",
  },
]

class MapObject extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      window: 0,
    }
  }

  componentDidMount = () => {
    if (windowGlobal) {
      this.setState({
        window: window.innerWidth,
      })
    }
  }

  render() {
    return (
      <ComposableMap height={400} projection={"geoMercator"}>
        <ZoomableGroup
          zoom={this.state.window > 768 ? 0.6 : 1}
          center={this.state.window > [768] ? [10, 10] : [10, 42]}
          disablePanning
          disableZooming
        >
          <Geographies geography={geoUrl}>
            {({ geographies }) =>
              geographies.map(geo => (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  fill="#DDD"
                  stroke="#FFF"
                />
              ))
            }
          </Geographies>
          <Marker
            coordinates={[24, 60]}
            onClick={() => this.props.setSelected(2)}
          >
            <Contact
              color={
                this.props.selected === 2
                  ? Settings.secondaryColor
                  : Settings.primaryColor
              }
            />
          </Marker>
          <Marker
            coordinates={[6, 58]}
            onClick={() => this.props.setSelected(1)}
          >
            <Contact
              color={
                this.props.selected === 1
                  ? Settings.secondaryColor
                  : Settings.primaryColor
              }
            />
          </Marker>
          <Marker
            coordinates={[1, 59]}
            onClick={() => this.props.setSelected(3)}
          >
            <Contact
              color={
                this.props.selected === 3
                  ? Settings.secondaryColor
                  : Settings.primaryColor
              }
            />
          </Marker>
          <Marker
            coordinates={[32, 42]}
            onClick={() => this.props.setSelected(4)}
          >
            <Contact
              color={
                this.props.selected === 4
                  ? Settings.secondaryColor
                  : Settings.primaryColor
              }
            />
          </Marker>
          <Marker
            coordinates={[73, 35]}
            onClick={() => this.props.setSelected(5)}
          >
            <Contact
              color={
                this.props.selected === 5
                  ? Settings.secondaryColor
                  : Settings.primaryColor
              }
            />
          </Marker>
          <Marker
            coordinates={[110, 40]}
            onClick={() => this.props.setSelected(0)}
          >
            <Contact
              color={
                this.props.selected === 0
                  ? Settings.secondaryColor
                  : Settings.primaryColor
              }
            />
          </Marker>
          <Marker
            coordinates={[136, 44]}
            onClick={() => this.props.setSelected(6)}
          >
            <Contact
              color={
                this.props.selected === 6
                  ? Settings.secondaryColor
                  : Settings.primaryColor
              }
            />
          </Marker>
          <Marker
            coordinates={[5, 54]}
            onClick={() => this.props.setSelected(7)}
          >
            <Contact
              color={
                this.props.selected === 7
                  ? Settings.secondaryColor
                  : Settings.primaryColor
              }
            />
          </Marker>
          <Marker
            coordinates={[-110, 45]}
            onClick={() => this.props.setSelected(8)}
          >
            <Contact
              color={
                this.props.selected === 8
                  ? Settings.secondaryColor
                  : Settings.primaryColor
              }
            />
          </Marker>
          <Marker
            coordinates={[-120, 65]}
            onClick={() => this.props.setSelected(9)}
          >
            <Contact
              color={
                this.props.selected === 9
                  ? Settings.secondaryColor
                  : Settings.primaryColor
              }
            />
          </Marker>
          <Marker
            coordinates={[11, 54]}
            onClick={() => this.props.setSelected(10)}
          >
            <Contact
              color={
                this.props.selected === 10
                  ? Settings.secondaryColor
                  : Settings.primaryColor
              }
            />
          </Marker>
          <Marker
            coordinates={[60, 65]}
            onClick={() => this.props.setSelected(11)}
          >
            <Contact
              color={
                this.props.selected === 11
                  ? Settings.secondaryColor
                  : Settings.primaryColor
              }
            />
          </Marker>
        </ZoomableGroup>
      </ComposableMap>
    )
  }
}

const Mapstyle = styled.div`
  position: relative;
  padding: 10rem 0 0;
  @media screen and (max-width: ${Settings.sizeL}) {
    padding: 1rem 0;
  }
  svg {
    svg {
      path {
        transform: scale(0.4);
      }
    }
  }
  .rsm-marker {
    position: relative;
    z-index: 999;
    cursor: pointer;
  }
  path {
    outline: none;
  }
  .mobileNav {
    display: none;
    border-bottom: 2px solid ${Settings.secondaryColor};
    .nav {
      position: relative;
    }
    .nav {
      h4,
      b {
        display: inline-block;
        margin: 1rem 0;
      }
    }
    b {
      font-size: 2rem;
      color: ${Settings.secondaryColor};
      float: right;
    }
    @media screen and (max-width: ${Settings.sizeM}) {
      display: block;
      h4 {
        color: ${Settings.secondaryColor};
        font-weight: 700;
        font-size: 1.5rem;
      }
    }
    .dropdown {
      display: none;
      position: absolute;
      top: 5rem;
      left: 50%;
      background: #fff;
      width: 100%;
      box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.5);
      z-index: 100;
      width: 90%;
      transform: translateX(-50%);
      h4 {
        margin: 2rem;
        color: #707070;
      }
      .selected {
        color: ${Settings.secondaryColor};
      }
    }
    .dropdown.show {
      display: block;
    }
  }
`

const ManualConstruction = styled.div`
  position: relative;
  background: #fff;
  width: 250px;
  padding: 1rem;
  position: absolute;
  left: ${props => (props.x ? props.x : 0)};
  top: ${props => (props.y ? props.y : 0)};
  @media screen and (max-width: ${Settings.sizeL}) {
    display: ${props => (props.selected === props.card ? "block" : "none")};
    margin: 0 5%;
    position: relative;
    left: 0 !important;
    top: 0 !important;
  }
  p,
  h4 {
    margin: 0;
  }
  h4 {
    font-weight: 700;
    font-size: 1.2rem;
    color: ${props => (props.selected === props.card ? "#F13945" : "#000")};
  }
  p {
    > b {
      color: ${props => (props.selected === props.card ? "#F13945" : "#000")};
    }
  }
  p {
    font-size: 0.9rem;
    opacity: 0.8;
  }
`

export class Map extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selected: 0,
      dropdown: false,
    }
  }

  setSelected = i => {
    this.setState({
      selected: i,
    })
  }

  setDropdown = status => {
    this.setState({
      dropdown: status,
    })
  }

  render() {
    return (
      <Mapstyle selected={this.state.selected}>
        <MapObject
          setSelected={this.setSelected}
          selected={this.state.selected}
        />
        <div className="constraint mobileNav">
          <div
            className="nav"
            onClick={() => this.setDropdown(!this.state.dropdown)}
          >
            <h4>{data[this.state.selected].country}</h4>
            <b>⌄</b>
          </div>
          <div className={this.state.dropdown ? "dropdown show" : "dropdown"}>
            {data.map((branch, i) => (
              <div>
                <h4
                  key={i}
                  onClick={() => {
                    this.setSelected(i)
                    this.setDropdown(!this.state.dropdown)
                  }}
                  className={this.state.selected === i ? "selected" : ""}
                >
                  {branch.country}
                </h4>
              </div>
            ))}
          </div>
        </div>
        {data.map((branch, i) => (
          <ManualConstruction
            key={i}
            x={branch.x}
            y={branch.y}
            selected={this.state.selected}
            card={i}
          >
            <div>
              <h4>{branch.country}</h4>
              <p>
                <b>{branch.name}</b>
              </p>
              <p>{branch.company}</p>
              <p>{branch.address}</p>
              {branch.tel ? <p>Tel: {branch.tel}</p> : ""}
              {branch.fax ? <p>Fax: {branch.fax}</p> : ""}
              {branch.mobile ? <p>Mobile: {branch.mobile}</p> : ""}
              <p>Email: {branch.email}</p>
            </div>
          </ManualConstruction>
        ))}
      </Mapstyle>
    )
  }
}
